<section class="flex justify-between mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Compañía</h1>
    <button class="button" (click)="openEditForm()">
        Editar
    </button>
</section>
@if(company){
<div class="grid grid-cols-1 md:grid-cols-3 gap-6">

    <section class="md:col-span-2 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <h2 class="text-sm font-semibold uppercase tracking-wider mb-4 text-indigo-500">Información
            General</h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
                <p class="text-sm text-gray-500">Nombre Legal</p>
                <p class="font-medium text-lg text-gray-900">{{company.name}}</p>
            </div>
            <div>
                <p class="text-sm text-gray-500">Identificación (CIF)</p>
                <p class="font-mono font-medium text-gray-900">{{company.cif}}</p>
            </div>
            <div>
                <p class="text-sm text-gray-500">Correo Electrónico</p>
                <a href="mailto:{{company.email}}"
                    class="text-indigo-600 hover:underline font-medium">{{company.email}}</a>
            </div>
            <div>
                <p class="text-sm text-gray-500">Fecha de Registro</p>
                <p class="text-gray-900 font-medium">{{company.created_at | date: 'd MMMM y'}}</p>
            </div>
        </div>
    </section>

    <section class="md:col-span-2 md:order-3 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <h2 class="text-sm font-semibold uppercase tracking-wider mb-4 text-indigo-500">Ubicación y
            Contacto</h2>

        @if(company.address || company.phone || company.phone_2){
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            @if(company.address){
            <div class="sm:col-span-2">
                <p class="text-sm text-gray-500">Dirección</p>
                <p class="text-gray-900 font-medium">{{company.address}}</p>
                <p class="text-sm text-gray-600">{{company.postal_code}} {{company.city}} ({{company.province}})</p>
            </div>
            }
            @if(company.phone){
            <div>
                <p class="text-sm text-gray-500">Teléfono Principal</p>
                <p class="text-gray-900 font-medium">{{company.phone}}</p>
            </div>
            }
            @if(company.phone_2){
            <div>
                <p class="text-sm text-gray-500">Teléfono Secundario</p>
                <p class="text-gray-900 font-medium">{{company.phone_2}}</p>
            </div>
            }
        </div>
        } @else {
        <div
            class="flex flex-col items-center justify-center py-8 text-center border-2 border-dashed border-gray-50 rounded-lg">
            <svg class="w-12 h-12 text-gray-200 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <p class="text-gray-400 italic text-sm">No hay datos de contacto registrados.</p>
        </div>
        }
    </section>

    <section class="md:order-2 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <div class="flex justify-between items-center mb-4">
            <h3 class="text-indigo-600 text-xs font-bold uppercase tracking-widest">Facturación</h3>
            <button type="button" (click)="openIbanForm()"
                class="cursor-pointer text-xs px-3 py-1.5 bg-indigo-50 text-indigo-600 rounded-lg hover:bg-indigo-100 transition font-medium">
                Gestionar IBANs
            </button>
        </div>

        <div class="space-y-3 text-sm mb-4">
            @if(company.iban && company.iban.length > 0){
            @for(item of company.iban; track $index){
            <div class="flex items-start justify-between p-3 bg-gray-50 rounded-lg border border-gray-100">
                <div>
                    <p class="text-xs text-gray-400 mb-0.5">{{ item.label }}</p>
                    <p class="font-mono font-medium text-gray-800 uppercase text-sm">{{ item.iban }}</p>
                </div>
                @if(item.is_primary){
                <span
                    class="text-xs bg-indigo-100 text-indigo-700 font-medium px-2 py-0.5 rounded-full shrink-0">Principal</span>
                }
            </div>
            }
            } @else {
            <div
                class="flex flex-col items-center justify-center py-6 text-center border-2 border-dashed border-gray-100 rounded-lg">
                <p class="text-gray-400 italic text-xs">No hay IBANs configurados</p>
            </div>
            }
        </div>

        <div class="pt-3 border-t border-gray-50 text-sm">
            <span class="text-gray-500 block mb-1">Serie de Factura:</span>
            <span class="font-medium text-gray-800">{{company.invoices_prefix || 'Por defecto'}}</span>
        </div>
    </section>

    <section class="md:order-4 flex flex-col bg-gray-50 p-6 rounded-xl border border-gray-200">
        <h3 class="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4">Sistema</h3>
        <ul class="space-y-3 text-sm">
            <li class="flex justify-between items-center">
                <span class="text-gray-500">Estado:</span>
                <span class="flex items-center gap-1.5 font-semibold" [class.text-green-600]="company.is_active"
                    [class.text-red-600]="!company.is_active">
                    <span class="h-1.5 w-1.5 rounded-full" [class.bg-green-500]="company.is_active"
                        [class.bg-red-500]="!company.is_active"></span>
                    {{company.is_active ? 'Activa' : 'Inactiva'}}
                </span>
            </li>
            @if(company.business_type){
            <li class="flex justify-between items-center">
                <span class="text-gray-500">Tipo de negocio:</span>
                <span class="font-semibold text-gray-800">
                    {{ { restaurant: 'Restaurante', store: 'Tienda', other: 'Otro' }[company.business_type] }}
                </span>
            </li>
            }
        </ul>

        <div class="mt-auto flex justify-between pt-2 border-t border-gray-200">
            <span class="text-gray-500 text-xs text-right w-full italic">Actualizado: {{company.updated_at |
                date: 'dd/MM/yy HH:mm'}}</span>
        </div>
    </section>

</div>

} @else {
<div class="grid grid-cols-1 md:grid-cols-3 gap-6 animate-pulse">

    <section class="md:col-span-2 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <div class="h-4 w-32 bg-indigo-100 rounded mb-6"></div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            @for(i of [1,2,3,4]; track i) {
            <div>
                <div class="h-3 w-24 bg-gray-200 rounded mb-2"></div>
                <div class="h-5 w-40 bg-gray-300 rounded"></div>
            </div>
            }
        </div>
    </section>

    <section class="md:col-span-2 md:order-3 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <div class="h-4 w-40 bg-indigo-100 rounded mb-6"></div>
        <div class="space-y-6">
            <div>
                <div class="h-3 w-20 bg-gray-200 rounded mb-2"></div>
                <div class="h-5 w-full bg-gray-300 rounded mb-2"></div>
                <div class="h-4 w-1/2 bg-gray-200 rounded"></div>
            </div>
            <div class="grid grid-cols-2 gap-6">
                <div class="h-10 bg-gray-200 rounded"></div>
                <div class="h-10 bg-gray-200 rounded"></div>
            </div>
        </div>
    </section>

    <section class="md:order-2 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <div class="h-4 w-24 bg-indigo-100 rounded mb-6"></div>
        <div class="space-y-4">
            <div>
                <div class="h-3 w-32 bg-gray-200 rounded mb-2"></div>
                <div class="h-5 w-full bg-gray-300 rounded"></div>
            </div>
            <div class="pt-4 border-t border-gray-50">
                <div class="h-3 w-28 bg-gray-200 rounded mb-2"></div>
                <div class="h-5 w-16 bg-gray-300 rounded"></div>
            </div>
        </div>
    </section>

    <section class="md:order-4 flex flex-col bg-gray-50 p-6 rounded-xl border border-gray-200">
        <div class="h-4 w-20 bg-gray-200 rounded mb-6"></div>
        <div class="flex justify-between items-center mb-10">
            <div class="h-4 w-16 bg-gray-200 rounded"></div>
            <div class="h-6 w-20 bg-gray-300 rounded-full"></div>
        </div>
        <div class="mt-auto pt-2 border-t border-gray-200">
            <div class="h-3 w-32 bg-gray-200 rounded ml-auto"></div>
        </div>
    </section>

</div>

}